var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUiIconMail = function SvgUiIconMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.182 7.124H19a1 1 0 0 1 1 1v7.684a1 1 0 0 1-1 1H5.182a1 1 0 0 1-1-1V8.124a1 1 0 0 1 1-1z",
    stroke: "currentColor",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.489 7.124 6.966 5.635a1 1 0 0 0 1.267-.007L19.659 7",
    stroke: "currentColor",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M7.905 12.634 4 15.812 5.015 17l3.927-3.345zM15.912 12.634l3.905 3.178L18.802 17l-3.927-3.345z"
  }))));
};
export default SvgUiIconMail;